import {
  getItemSku,
  getDiscount,
  getItemCategory,
  getItemCategory2,
  getItemCategory4,
  getItemShippingTier,
} from '../../utils';

export async function itemsFromItem(context: Record<string, any>) {
  const { item, orderForm } = context;
  return [
    {
      item_id: item.productId,
      item_category2: getItemCategory2(item),
      item_category4: getItemCategory4(item),
      item_shipping_tier: getItemShippingTier(orderForm, item),
      price: parseFloat((item.price / 100).toFixed(2)) || 0,
      quantity: 1,
      item_ref: item.refId || null,
      item_brand: item.additionalInfo?.brandName || null,
      item_sku: (await getItemSku(item)) || item.id || null,
      item_name: item.name || item.id || null,
      item_category: getItemCategory(item) || null,
      item_variant: item.skuName.split('-')[0].trim(),
      item_variant2: item.skuName.split('-').pop()?.trim() || '',
      discount: getDiscount(item),
      
      item_list_name: null,
      index: 0
    },
  ];
}
